import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import { StudentPositions } from '../../types';

export interface ExerciseFieldProps {
  control: Control<any>;
  studentPositions?: StudentPositions[];
  loading?: boolean;
  name: string;
}

const PositionsField = ({ control, studentPositions, loading, name }: ExerciseFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: { required: 'Please select a position' } });

  const getOptionLabel = option => {
    const studentPosition = studentPositions?.find(e => e.name === option.name);
    const envPosition = studentPosition?.position ? ` (${studentPosition?.position})` : ``;

    return studentPosition ? `${studentPosition?.name}${envPosition}` : '';
  };

  return (
    <Autocomplete
      data-cy="select-position"
      clearOnBlur
      disableClearable
      disabled={!studentPositions || studentPositions.length === 1}
      handleHomeEndKeys
      getOptionLabel={getOptionLabel}
      renderOption={(props, option) => (
        <li {...props} key={option.name} data-cy={`select-option-${getOptionLabel(option)}`}>
          {getOptionLabel(option)}
        </li>
      )}
      options={studentPositions || []}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          error={!!error}
          helperText={error?.message}
          label="Student environment"
          required
        />
      )}
      {...field}
      onChange={(event, option) => {
        field.onChange(option);
      }}
    />
  );
};

export default PositionsField;
